import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('enable_redaction_support_in_jira_issue_view');
	},
};
